import { Component, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import {postData, postFile, updateData} from './constants.js';
const moment = require('moment');

function ViolationList(props) {
    const violation_list = props.data.map((item)=>
      <tr key={item.id} id={item.id}>
          <td>{moment(item.created_date).format("l")}</td>
          <td>{item.created_user}</td>
          <td>{item.violation_type}</td>
          <td className="text-nowrap">{item.status?'Closed':'Pending'}</td>
          <td className="text-center"><Link className="font-weight-bold text-warning" to={'/edit-violation/'+item.id}><i className="fas fa-pencil-alt"></i></Link></td>
          <td><Link id={item.id} className="font-weight-bold" to={'/violation/'+item.id}>View details</Link></td>
      </tr>
    );
    return(
        <>
        <div className="row">
            <div className="col-xs-12 col-md-12">
                <div className="card shadow mb-2">
                    <div className="card-header py-3">
                        <h4 className="m-0 font-weight-bold text-white">Violations</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive violation-table">
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>Violation Date</th>
                                        <th>Filed By</th>
                                        <th>Type of Violation</th>
                                        <th>Status</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                      {violation_list}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Link className="btn btn-primary" to="/add-violation"><i className="fas fa-plus"></i> New Violation</Link>
            </div>
        </div>
        </>
    );
}

class Violations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true
    };
  }

  async getViolations() {
    try {
      const response = await fetch('/api/violations');
      const json = await response.json();
      console.log(json);
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getViolations();
  }

  render() {
    return (
      <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <ViolationList data={this.state.data} />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
      </>
    );
  }
}

class ViolationForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        residents       :[],
        id              :"",
        violation_type  :"Landscaping",
        other_violation :"",
        description     :"",
        resident_id     :"",
        isLoading       :true,
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleFileChange = this.handleFileChange.bind(this);
    }

    async getResidentList() {
      try {
        const response = await fetch('/api/residents');
        const json = await response.json();
        console.log(json);
        this.setState({residents: json});
        if(!this.state.resident_id && json.length){
          this.setState({resident_id: json[0].id});
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.setState({isLoading: false})
      }
    }

    async getViolation(id) {
      try {
        const response = await fetch('/api/violation/'+id);
        const json = await response.json();
        console.log(json);
        this.setState(json.violation);
      } catch (error) {
        console.log(error);
      }
    }

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;
      this.setState({
        [name]: value
      });
    }

    handleFileChange(event) {
      this.setState({
        "filename":event.target.files[0].name
      })
    }

    handleSubmit(event) {
      event.preventDefault();
      var formData = new FormData();
      var file = document.getElementById("inputGroupFile01").files[0];
		  formData.append('File', file);
      var data = this.state;
      console.log("data", data);
      delete data.isLoading;

      formData.append('jsonData', JSON.stringify(data));

      postFile('/api/violation', formData)
        .then((response) => {
          console.log(response);
          this.props.navigate('/violations');
      });
    }

    componentDidMount() {
      if(this.props.violationId) {
        this.getViolation(this.props.violationId);
      }
      this.getResidentList();
    }

    render() {
      if(!this.state.isLoading){
        const data = this.state;
        const resident_list = this.state.residents.map((r) =>
            <option key={r.id} value={r.id}>{r.lot_no+", "+r.first_name+" "+r.last_name}</option>
        );
        return(
          <div className="card shadow mb-4">
              <div className="card-header py-3">
                  <h4 className="m-0 font-weight-bold text-light">Violation Registration</h4>
              </div>
              <div className="card-body">
                <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                    <div className="row">
                        <div className="col-lg-6 col-xs-12">
                            <div className="form-group">
                                <label>Type of Violation</label>
                                <select className="form-select" name="violation_type" value={data.violation_type} onChange={this.handleInputChange}>
                                   <option>Landscaping</option>
                                   <option>Vehicles and parking</option>
                                   <option>Renting out your home</option>
                                   <option>Trash pickup</option>
                                   <option>Exterior storage</option>
                                   <option>Pets</option>
                                   <option>Noise</option>
                                   <option>Holiday decorations</option>
                                   <option>Design changes</option>
                                   <option>Others</option>
                                </select>
                            </div>
                        </div>
                        {data.violation_type==="Others" &&
                          <div className="col-lg-6 col-xs-12">
                              <div className="form-group">
                                <label>Violation Description</label>
                                <input className="form-control" name="other_violation" maxLength={100} value={data.other_violation} onChange={this.handleInputChange} required />
                              </div>
                          </div>
                        }
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-xs-12">
                            <div className="form-group">
                              <label>Select Property</label>
                              <select className="form-select" name="resident_id" value={data.resident_id} onChange={this.handleInputChange}>
                                 {resident_list}
                              </select>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xs-12">
                            <div className="form-group">
                              <label>Attachments</label>
                              <div className="input-group input-group-sm">
                                  <div className="custom-file">
                                     <input type="file" className="custom-file-input form-control form-control-sm" id="inputGroupFile01" onChange={this.handleFileChange} aria-describedby="inputGroupFileAddon04" />
                                     <label className="custom-file-label" for="inputGroupFile01">Choose file</label>
                                  </div>
                              </div>
                              <p className="text-success">{data.filename}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xs-12 d-flex align-items-center">
                          {data.file_ref &&
                            <>
                              <a href={data.file_ref} target="_blank" className="text-primary"><small>{data.file_ref}</small></a>
                            </>
                          }
                        </div>
                        <div className="col-lg-12 col-xs-12">
                            <div className="form-group">
                                <label>The specific details of the violation</label>
                                <textarea type="text" name="description" rows="5" maxLength={500} className="form-control form-control-sm" value={data.description} onChange={this.handleInputChange} required />
                            </div>
                        </div>
                        <div className="col-lg-10 col-xs-12">
                            <div className="form-group">
                              <input type="submit" id="asset-submit" className="btn btn-bg-success" value="Submit" />
                              <Link to="/violations" className="btn ms-3 btn-danger">Cancel</Link>
                            </div>
                        </div>
                    </div>
                </form>
              </div>
          </div>
        );
      }
    }
}

function NewViolation() {
    let navigate = useNavigate();
    return (
      <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                      <ViolationForm navigate={navigate} />
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
      </>
    );
}

function EditViolation() {
    const { id } = useParams();
    console.log("violationId", id);
    let navigate = useNavigate();
    return (
      <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                      <ViolationForm navigate={navigate} violationId={id} />
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
      </>
    );
}

class ViolationResponseForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        violation_id   :this.props.violationId,
        response_text  :"",
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;
      this.setState({
        [name]: value
      });
    }

    handleSubmit(event) {
      event.preventDefault();
      var data = this.state;
      console.log(data);
      postData('/api/violation_response', data)
        .then((response) => {
          console.log(response);
          this.setState({'response_text': ''})
          this.props.getViolationDetails();
      });
    }

    render() {
      return(
        <form className="user mt-2" onSubmit={this.handleSubmit} autoComplete="off">
          <fieldset id="violation-response-form">
            <small className="fw-bold">Comment </small>
            <div className="row">
                <div className="col-lg-12 col-xs-12">
                    <div className="input-group">
                      <input type="text" name="response_text" value={this.state.response_text} onChange={this.handleInputChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" required />
                      <div className="input-group-append">
                        <button className="btn btn-outline-primary input-group-button"><i className="fas fa-comment-alt action-buttons"></i></button>
                      </div>
                    </div>
                </div>
            </div>
          </fieldset>
        </form>
      );
    }
}

class ViolationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id     : this.props.data.id,
      status : this.props.data.status
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    updateData('/api/violation-status/'+data.id, data)
      .then((response) => {
        console.log(response);
        this.props.navigate("/violations");
    });
  }

  render(){
    var data = this.props.data;
    const violation_responses = this.props.responses.map((item,index)=>{
      return(
        <div key={item.id} className="row no-gutters my-1">
          <div className={item.commented_resident?"col-12 d-flex justify-content-end":"col-12 text-dark"}>
            {item.response_text}
          </div>
          <div className={item.commented_resident?"col-12 d-flex justify-content-end":"col-12"}>
            <small className="mx-2">{item.commented_user},</small>
            <small className="m-0">{moment(item.created_date).format("lll")}</small>
          </div>
        </div>
      );
    });
    return (
      <>
        <div className="row">
          <div className="col-xs-12 col-md-6 col-lg-8">
            <div className="card shadow-sm mb-2">
                <div className="card-header py-3">
                    <h4 className="m-0 font-weight-bold text-light">Violation Details</h4>
                </div>
                <div className="card-body acc-approval-form">
                  <div className="row mb-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Violation Registerd on </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.created_date).format("LLL")} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Violation Filed by </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.created_user} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Type of Violation </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.violation_type} </div>
                  </div>
                  {data.other_violation &&
                    <div className="row my-3">
                      <div className="col-xs-6 col-md-4 font-weight-bold">Violation Description </div>
                      <div className="col-xs-6 col-md-8 font-weight-bold"> {data.other_violation} </div>
                    </div>
                  }
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Violation's Status </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.status?'Closed':'Pending'} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Violation Details </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.description} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4">
                      <a href={data.file_ref} target="_blank" className="fw-bold hyperlink"> View attachments </a>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-xs-6 col-md-4">
                      <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                          <div className="form-group">
                              <label>Update Violation Status</label>
                              <select name="status" className="form-select" value={this.state.status} onChange={this.handleInputChange}>
                                  <option value={0}>Pending</option>
                                  <option value={1}>Closed</option>
                              </select>
                          </div>
                          <div className="form-group mb-0">
                            <input type="submit" className="btn btn-bg-success mr-2" value="Submit" />
                            <Link to="/violations" className="btn btn-danger">Cancel</Link>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 col-lg-4">
            <div className="card shadow mb-2">
              <div className="card-header">
                  <h4 className="m-0 font-weight-bold text-light">Responses</h4>
              </div>
              <div className="card-body">
                <div className="violation-response-view">
                  {violation_responses}
                </div>
                <ViolationResponseForm violationId={data.id} getViolationDetails={this.props.getViolationDetails} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function ViewViolation() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [violationData, setViolationData] = useState({});
  const [violationResponses, setViolationResponses] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const getViolationDetails = async() => {
    try {
      const response = await fetch('/api/violation/'+id);
      const json = await response.json();
      setViolationData(json.violation);
      setViolationResponses(json.violation_responses);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    getViolationDetails();
  }, []);

  return(
    <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                    {!isLoading?
                      <ViolationDetails data={violationData} responses={violationResponses} getViolationDetails={getViolationDetails} navigate={navigate} />
                    :
                      <> </>
                    }
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
    </>
  );
}

export { Violations, NewViolation, EditViolation, ViewViolation };
